import { render } from "./SocialMedia.vue?vue&type=template&id=031425c0&ts=true"
import script from "./SocialMedia.vue?vue&type=script&lang=ts"
export * from "./SocialMedia.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__